import React, { useState, useEffect } from 'react'
import Modal from '../Modal'
import Button from '../Button'
import CardSolution from '../CardSolution'
import GeozoneLogo from '../../assets/svg/logo-geozone.svg'
import GeolocatorLogo from '../../assets/svg/geolocator.svg'
import GeocommentLogo from '../../assets/svg/geocomment.svg'
import ArcGISurbanLaunchKitLogo from '../../assets/arcgis-urban-launch-kit.png'
import ArcGISHubLogo from '../../assets/arcgis-hub.png'
import ArcGISDataHealthChecksLogo from '../../assets/arcgis-data-health-checks.png'
import ArcGISBusinessAnalystLogo from '../../assets/arcgis-business-analyst.png'
import GISLaunchKit3dLogo from '../../assets/svg/3d-gis-launch-kit.svg'
import ArcGISLaunchKitLogo from '../../assets/arcgis-online-launch-kit.png'
import ArcGISEnterpriseLaunchKitLogo from '../../assets/arcgis-enterprice-launch-kit.png'
import ArcGISEnterpriceCloudLaunchKitLogo from '../../assets/arcgis-enterprice-cloud-launch-kit.png'
import FieldOperationslaunchKitLogo from '../../assets/field-operations-launch-kit.png'
import ArcGISUtilityNetworkLogo from '../../assets/arcgis-utility-network.png'
const ProductModal = props => {
    const [enabled, setEnabled] = useState(props.isVisible)
    useEffect(() => {
        setEnabled(props.isVisible)
    }, [props.isVisible])
    return (
        <Modal isOpen={enabled} closeTrigger={props.closeTrigger}>
            <div>
                <div className="flex justify-between items-center">
                    <h4>All products list</h4>
                    <Button btnStyle="primary-outline" text="Back to Dashboard" onClick={() => {
                        setEnabled(false)
                        props.closeTrigger()
                    }} />
                </div>
                <div className="pb-2 mb-4 border-b border-vp-lightbrown">
                    <h2 className="text-xle font-bold my-6">Planning &amp; Zoning</h2>
                    <div className="flex flex-wrap  -mr-5">
                        <CardSolution
                            logo={GeozoneLogo}
                            checked
                            departments={[
                                {
                                    cardname: "PZ",
                                    cardhover: "Planning & Zoning"
                                },
                                {
                                    cardname: "PW",
                                    cardhover: "Public Works"
                                },
                                {
                                    cardname: "GIS",
                                    cardhover: "GIS / IT"
                                },
                                {
                                    cardname: "UD",
                                    cardhover: "Urban Design"
                                },
                                {
                                    cardname: "C",
                                    cardhover: "Communications"
                                },
                                {
                                    cardname: "ED",
                                    cardhover: "Economic Development"
                                }]}
                            diffultyLevel="Easy"
                            features={[
                                <>Built <strong>around</strong> Planners’ needs</>,
                                <>Accurately <strong>analyze</strong> and review Zoning ordinances</>,
                                <>Custom tools - Land use and Zoning look-up functionality</>
                            ]}
                            learnMoreLink="https://www.viewprogis.com/geozone"
                            demoLink="https://map.viewprogis.com/demo/cc-fl?widget=334ea888-74a3-4dd5-bca2-cd9460cca91b"
                        />
                        <CardSolution
                            logo={ArcGISurbanLaunchKitLogo}
                            checked
                            departments={[{
                                cardname: "PZ",
                                cardhover: "Planning & Zoning"
                            },
                            {
                                cardname: "PW",
                                cardhover: "Public Works"
                            },
                            {
                                cardname: "GIS",
                                cardhover: "GIS / IT"
                            },
                            {
                                cardname: "UD",
                                cardhover: "Urban Design"
                            },
                            {
                                cardname: "C",
                                cardhover: "Communications"
                            },
                            {
                                cardname: "ED",
                                cardhover: "Economic Development"
                            }]}
                            diffultyLevel="Advanced"
                            features={[
                                <>Create a digital twin </>,
                                <>3D immersive experience</>,
                                <>Configure what-if scenarios</>,
                                <>Measure impacts of proposed planning scenarios</>
                            ]}
                            learnMoreLink="https://www.viewprogis.com/arcgis-urban-deployment"
                            demoLink="https://urban.arcgis.com/?id=e120bcbd6f7b4250acff9bd16630dd48"
                        />
                        <CardSolution
                            logo={GeocommentLogo}
                            checked
                            departments={[{
                                cardname: "PZ",
                                cardhover: "Planning & Zoning"
                            },
                            {
                                cardname: "GIS",
                                cardhover: "GIS / IT"
                            },
                            {
                                cardname: "UD",
                                cardhover: "Urban Design"
                            },
                            {
                                cardname: "C",
                                cardhover: "Communications"
                            },]}
                            diffultyLevel="Easy"
                            features={[
                                <>Map based and highly intuitive <strong>Citizen Engagement tool</strong></>,
                                <><strong>Secured curation</strong> of the incoming feedback</>,
                                <>Easy to use interface, requires little or no technical training</>,
                            ]}
                            learnMoreLink="https://viewprogis.com"
                            demoLink="https://maps.viewprogis.com/vp/US67-test"
                        />
                        <CardSolution
                            logo={ArcGISHubLogo}
                            checked
                            departments={[{
                                cardname: "PZ",
                                cardhover: "Planning & Zoning"
                            },
                            {
                                cardname: "GIS",
                                cardhover: "GIS / IT"
                            },
                            {
                                cardname: "UD",
                                cardhover: "Urban Design"
                            },
                            {
                                cardname: "C",
                                cardhover: "Communications"
                            },]}
                            diffultyLevel="Medium"
                            features={[
                                <>Offers advanced tools to engage with the audience</>,
                                <>Create &amp; manage multiple planning initiatives </>,
                                <>Integrate event management and surveys all in one platform</>
                            ]}
                            learnMoreLink="https://www.esri.com/en-us/arcgis/products/arcgis-hub/overview"
                        />

                        <CardSolution
                            logo={GeolocatorLogo}
                            checked
                            departments={[{
                                cardname: "PZ",
                                cardhover: "Planning & Zoning"
                            },
                            {
                                cardname: "GIS",
                                cardhover: "GIS / IT"
                            },
                            {
                                cardname: "ED",
                                cardhover: "Economic Development"
                            }]}
                            diffultyLevel="Easy"
                            features={[
                                <>A <strong>Site-Selection</strong> tool to aide Economic Development</>,
                                <>Provides <strong>real-time access</strong> to Esri curated data and reports</>,
                                <>Access to 3rd party commercial listings for sale/leasey</>
                            ]}
                            learnMoreLink="https://www.viewprogis.com/geolocator"
                            demoLink="https://maps.viewprogis.com/ecp/richmondedc-tx"
                        />
                        <CardSolution
                            logo={ArcGISBusinessAnalystLogo}
                            checked
                            departments={[{
                                cardname: "PZ",
                                cardhover: "Planning & Zoning"
                            },
                            {
                                cardname: "GIS",
                                cardhover: "GIS / IT"
                            },
                            {
                                cardname: "ED",
                                cardhover: "Economic Development"
                            }]}
                            diffultyLevel="Medium"
                            features={[
                                <>Help make informed data driven decisions for Site Selction and market planning</>,
                                <>Access to curated reports for demographics, lifestyle, spending and census data</>
                            ]}
                            learnMoreLink="https://www.esri.com/en-us/arcgis/products/arcgis-business-analyst/overview"
                        />
                        <CardSolution
                            logo={GISLaunchKit3dLogo}
                            checked
                            departments={[{
                                cardname: "PZ",
                                cardhover: "Planning & Zoning"
                            },
                            {
                                cardname: "GIS",
                                cardhover: "GIS / IT"
                            },
                            {
                                cardname: "UD",
                                cardhover: "Urban Design"
                            },
                            {
                                cardname: "ED",
                                cardhover: "Economic Development"
                            }]}
                            diffultyLevel="Advanced"
                            features={[
                                <>Create detailed 3D building context using LiDar files</>,
                                <>Create as-built environment to conceptualize your vision</>,
                                <>See patterns and trends using 3D contextual data models</>
                            ]}
                            learnMoreLink="https://storymaps.arcgis.com/stories/f988bfdb6baa43d49156ba91facb300f"
                            demoLink="https://storymaps.arcgis.com/stories/f988bfdb6baa43d49156ba91facb300f"
                        />

                    </div>
                </div>
                <div className="pb-2 mb-4 border-b border-vp-lightbrown">
                    <h2 className="text-xle font-bold my-6">Public Works</h2>
                    <div className="flex flex-wrap  -mr-5">
                        <CardSolution
                            logo={ArcGISUtilityNetworkLogo}
                            checked
                            departments={[{
                                cardname: "PW",
                                cardhover: "Public Works"
                            },
                            {
                                cardname: "GIS",
                                cardhover: "GIS / IT"
                            }]}
                            diffultyLevel="Advanced"
                            features={[
                                <>Capture the operational requirements of utility assets</>,
                                <>Model operation and maintain network integrity</>,
                                <>Model utility assets at the right scale to match your needs</>
                            ]}
                            learnMoreLink="https://www.esri.com/en-us/arcgis/products/arcgis-utility-network/overview"
                        />

                        <CardSolution
                            logo={FieldOperationslaunchKitLogo}
                            checked
                            departments={[{
                                cardname: "PW",
                                cardhover: "Public Works"
                            },
                            {
                                cardname: "GIS",
                                cardhover: "GIS / IT"
                            }]}
                            diffultyLevel="Medium"
                            features={[
                                <>Replace paper processes with with a configurable single app</>,
                                <>Real-time location awareness</>,
                                <>All-in-one app to help field workers with data collection, editing and finding assets</>
                            ]}
                            learnMoreLink="https://www.esri.com/en-us/arcgis/products/field-operations/overview"
                        />
                        <CardSolution
                            logo={ArcGISDataHealthChecksLogo}
                            checked
                            departments={[{
                                cardname: "PZ",
                                cardhover: "Planning & Zoning"
                            },
                            {
                                cardname: "PW",
                                cardhover: "Public Works"
                            },
                            {
                                cardname: "GIS",
                                cardhover: "GIS / IT"
                            }]}
                            diffultyLevel="Medium"
                            features={[
                                <>Performs a data diagnostic to achieve consistent quality</>,
                                <>Automatic detection of issues such as feature integrity and spatial inaccuracies</>,
                                <>Achieve consistent data quality</>
                            ]}
                            learnMoreLink="https://www.esri.com/en-us/arcgis/products/arcgis-data-reviewer/overview"
                        />
                        <CardSolution
                            logo={ArcGISLaunchKitLogo}
                            checked
                            departments={[{
                                cardname: "PZ",
                                cardhover: "Planning & Zoning"
                            },
                            {
                                cardname: "PW",
                                cardhover: "Public Works"
                            },
                            {
                                cardname: "GIS",
                                cardhover: "GIS / IT"
                            },
                            {
                                cardname: "UD",
                                cardhover: "Urban Design"
                            },
                            {
                                cardname: "C",
                                cardhover: "Communications"
                            },
                            {
                                cardname: "ED",
                                cardhover: "Economic Development"
                            }]}
                            diffultyLevel="Medium"
                            features={[
                                <>Enables 3D decision making</>,
                                <>Helps you to decipher complex zoning ordinance with ease and accuracy</>
                            ]}
                            learnMoreLink="https://www.arcgis.com/apps/Cascade/index.html?appid=c7ae358cb923443fb3e61f49c86bdbc9"
                        />
                    </div>
                </div>
                <div >
                    <h2 className="text-xle font-bold my-6">GIS - IT</h2>
                    <div className="flex flex-wrap  -mr-5">
                        <CardSolution
                            logo={ArcGISEnterpriseLaunchKitLogo}
                            checked
                            departments={[{
                                cardname: "GIS",
                                cardhover: "GIS / IT"
                            }]}
                            diffultyLevel="Advanced"
                            features={[
                                <>Advanced GIS foundation that support work behind a firewall and on premise</>,
                                <>Add special server extensions to optimize your needs</>
                            ]}
                            learnMoreLink="https://www.esri.com/en-us/arcgis/products/arcgis-enterprise/overview"
                        />
                        <CardSolution
                            logo={ArcGISEnterpriceCloudLaunchKitLogo}
                            checked
                            departments={[{
                                cardname: "GIS",
                                cardhover: "GIS / IT"
                            }]}
                            diffultyLevel="Advanced"
                            features={[
                                <>Advanced GIS foundation that support work behind a firewall and on a cloud</>,
                                <>A complete kit to kickstart your cloud based Enterprise solution</>
                            ]}
                            learnMoreLink="https://www.esri.com/en-us/landing-page/industry/government/2019/small-local-government-cbea"
                        />
                        <CardSolution
                            logo={ArcGISDataHealthChecksLogo}
                            checked
                            departments={[{
                                cardname: "PZ",
                                cardhover: "Planning & Zoning"
                            },
                            {
                                cardname: "PW",
                                cardhover: "Public Works"
                            },
                            {
                                cardname: "GIS",
                                cardhover: "GIS / IT"
                            }]}
                            diffultyLevel="Medium"
                            features={[
                                <>Performs a data diagnostic to achieve consistent quality</>,
                                <>Automatic detection of issues such as feature integrity and spatial inaccuracies</>,
                                <>Achieve consistent data quality</>
                            ]}
                            learnMoreLink="https://www.esri.com/en-us/arcgis/products/arcgis-data-reviewer/overview"
                        />
                        <CardSolution
                            logo={ArcGISLaunchKitLogo}
                            checked
                            departments={[{
                                cardname: "PZ",
                                cardhover: "Planning & Zoning"
                            },
                            {
                                cardname: "PW",
                                cardhover: "Public Works"
                            },
                            {
                                cardname: "GIS",
                                cardhover: "GIS / IT"
                            },
                            {
                                cardname: "UD",
                                cardhover: "Urban Design"
                            },
                            {
                                cardname: "C",
                                cardhover: "Communications"
                            },
                            {
                                cardname: "ED",
                                cardhover: "Economic Development"
                            }]}
                            diffultyLevel="Medium"
                            features={[
                                <>Enables 3D decision making</>,
                                <>Helps you to decipher complex zoning ordinance with ease and accuracy</>
                            ]}
                            learnMoreLink="https://www.arcgis.com/apps/Cascade/index.html?appid=c7ae358cb923443fb3e61f49c86bdbc9"
                        />
                        <CardSolution
                            logo={FieldOperationslaunchKitLogo}
                            checked
                            departments={[{
                                cardname: "PW",
                                cardhover: "Public Works"
                            },
                            {
                                cardname: "GIS",
                                cardhover: "GIS / IT"
                            }]}
                            diffultyLevel="Medium"
                            features={[
                                <>Replace paper processes with with a configurable single app</>,
                                <>Real-time location awareness</>,
                                <>All-in-one app to help field workers with data collection, editing and finding assets</>
                            ]}
                            learnMoreLink="https://www.esri.com/en-us/arcgis/products/field-operations/overview"
                        />
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default ProductModal